import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PageHero } from "@/components/common/Bits";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { getChairmanship } from "@/data/chairmanships";

export default function ChairmanshipDetailPage() {
  const { slug } = useParams();
  const { t, lang } = useLanguage();
  const [parentArea, setParentArea] = useState(null);
  const item = getChairmanship(slug);

  useEffect(() => {
    if (!item) return;
    api.get(`/activity-areas/${item.parent}?_=${Date.now()}`)
      .then((r) => setParentArea(r.data))
      .catch(() => setParentArea(null));
  }, [item?.parent]);

  if (!item) {
    return (
      <div className="useko-container py-32 text-center" data-testid="chairmanship-not-found">
        <h1 className="font-heading text-3xl font-bold text-[#EDE4CE]">{t.not_found_title}</h1>
        <Link to="/" className="btn-primary mt-6 inline-flex">{t.back_to_home}</Link>
      </div>
    );
  }

  const typeLabel = item.type === "sektorel"
    ? (t.chair_type_sektorel || "Sektörel Başkanlık")
    : (t.chair_type_fonksiyonel || "Fonksiyonel Başkanlık");
  const email = parentArea?.button_label || "info@useko.org";
  const parentTitle = parentArea?.title || "";
  const chairName = item.name[lang] || item.name.tr;

  return (
    <div data-testid={`chairmanship-${slug}`}>
      <PageHero overline={typeLabel} title={chairName} description={t.chair_intro_desc}/>
      <section className="py-20 useko-container grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8">
          <div className="prose-useko rich-content">
            <h2>{t.chair_scope_heading || "Görev Alanı"}</h2>
            <p>
              {(t.chair_scope_body || "Bu başkanlık, {parent} faaliyet alanı kapsamında görev yapmaktadır. Yönetim Kurulu tarafından belirlenen görev tanımları çerçevesinde; ilgili sektör/fonksiyonda strateji geliştirir, projeler yürütür ve paydaşlarla iş birliği sağlar.").replace("{parent}", parentTitle)}
            </p>
            <h2>{t.chair_activities_heading || "Faaliyetlerimiz"}</h2>
            <ul>
              <li>{t.chair_bullet_1 || "Strateji, yol haritası ve politika geliştirme"}</li>
              <li>{t.chair_bullet_2 || "Ulusal ve uluslararası paydaşlarla iş birliği"}</li>
              <li>{t.chair_bullet_3 || "Araştırma, rapor ve öneri hazırlığı"}</li>
              <li>{t.chair_bullet_4 || "Proje geliştirme ve uygulama"}</li>
              <li>{t.chair_bullet_5 || "Kapasite geliştirme ve bilgi paylaşımı"}</li>
            </ul>
          </div>

          <div className="mt-10">
            <h2 className="font-heading text-2xl font-bold text-[#EDE4CE] mb-2">{t.area_contact_heading}</h2>
            <p className="text-[#EDE4CE]/80 text-base leading-relaxed mb-5">{t.area_contact_body}</p>
            <span
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-br from-[#E8C577] via-[#D4A94F] to-[#B8862F] text-[#051436] font-bold text-sm cursor-default select-text"
              data-testid={`chair-email-${slug}`}
            >
              {email}
            </span>
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-3xl border border-[#D4A94F]/25 bg-gradient-to-br from-[#0A1F4A] to-[#051436] p-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4A94F] mb-3">{t.chair_parent_overline || "Bağlı Olduğu Faaliyet Alanı"}</div>
            <h3 className="font-heading text-2xl text-[#EDE4CE] leading-tight mb-4">{parentTitle}</h3>
            <Link to={`/faaliyet-alanlari/${item.parent}`} className="inline-flex items-center gap-2 text-[#D4A94F] hover:text-[#F5DE8C] font-medium text-sm">
              {t.btn_learn_more || "Detaylı İncele"} →
            </Link>
          </div>
        </aside>
      </section>
    </div>
  );
}
